<template>
  <div class="flex column">
    <SAIInput
      class="sai-counter"
      type="number"
      v-bind="$attrs"
      :min="min"
      :max="max"
      :value="value"
      :clearable="false"
      :disable="disable"
      :error="error"
      :hint="undefined"
      @input="update"
      @clear="$emit('clear', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    >
      <template v-slot:before>
        <QBtn
          outline
          round
          color="primary"
          size="12px"
          padding="6px"
          :disable="disable || value <= min"
          :error="error"
          icon="eva-minus-outline"
          @click="subtract"
        />
      </template>
      <template v-slot:after>
        <QBtn
          outline
          round
          color="primary"
          size="12px"
          padding="6px"
          :disable="disable || value >= max"
          :error="error"
          icon="eva-plus-outline"
          @click="add"
        />
      </template>
    </SAIInput>
    <span v-if="hint" class="text-body3 q-mt-sm text-grey-5">{{ hint }}</span>
  </div>
</template>

<script>
import { QBtn } from 'quasar';

export default {
  name: 'SAICounter',
  props: {
    value: {
      type: Number,
      default: 0
    },
    disable: {
      type: Boolean
    },
    error: {
      type: Boolean
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    hint: {
      type: String
    }
  },
  methods: {
    add() {
      this.update(this.value + 1);
    },
    subtract() {
      this.update(this.value - 1);
    },
    update(value) {
      if (isNaN(value)) {
        return undefined;
      }
      let parsedNumber = Number(value);
      if (!isNaN(this.min) && value < this.min) {
        return;
      }
      if (!isNaN(this.max) && value > this.max) {
        return;
      }
      this.$emit('input', parsedNumber);
    }
  },
  components: {
    QBtn,
    SAIInput: () => import('../sai-input')
  }
};
</script>

<style lang="sass" scoped>
.sai-counter::v-deep
  position: relative

  .q-field__control
    z-index: -1
    border-radius: 50px

  input
    text-align: center

  .q-field__before
    z-index: 1
    position: absolute
    padding: 6px
    padding-left: 8px
    left: 0

  .q-field__after
    position: absolute
    right: 0
    padding: 6px
    padding-right: 8px

  .q-btn__wrapper
    padding: 4px 12px

  .q-field__before .q-btn--outline .q-btn__wrapper:before,
  .q-field__after .q-btn--outline .q-btn__wrapper:before
    border-width: 2px
</style>
